<template>
    <section>
        Coming Soon....
    </section>
</template>

<script>
export default {
    name: "NewProducts"
}
</script>

<style scoped>

</style>